import { AuthContext, AuthContextState } from "lib/providers/authProvider";
import { useContext } from "react";

export const useAuth = (): AuthContextState => useContext(AuthContext);
